module.exports = "/fonts/tarra-h2h-picturemark-d-efa281fd92279a390b746033680f4938.svg";